import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { OpendialogCustomizeMySessionComponent } from 'app/components/dialog/open-dialog-customize-my-session/opendialog-customize-my-session.component';
import { SelectBasketOffer } from 'app/shared/models/class/basket/basketList';
import { CounterTraineeQuantity } from 'app/shared/models/class/counter/counter';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { SessionBasket, SessionBasketTraineeQuantity } from 'app/shared/models/class/session-basket/session-basket';
import { OfferSession } from 'app/shared/models/class/session/session';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { SessionBasketService } from 'app/shared/services/session-basket/session-basket.service';
import { UiService } from 'app/shared/services/ui/ui.service';

@Component({
  selector: 'app-manage-quantity',
  templateUrl: './manage-quantity.component.html',
  styleUrls: ['./manage-quantity.component.scss']
})
export class ManageQuantityComponent implements OnInit, OnChanges {

  @Input() myShoppingBag: FullOffer[];
  @Input() offer: FullOffer | any;
  @Input() index: number;
  @Input() type: string;
  @Input() userKeyInAdmin: number;
  @Input() counterSessionBasketKey: number;
  @Input() isCounter: boolean;
  @Input() isBasketInCounter = false;
  @Input() updateQuantityValue: number;
  @Input() priceWithoutSessions: number;

  @Output() updateQuantityValues = new EventEmitter<SessionBasketTraineeQuantity | CounterTraineeQuantity>();
  @Output() getCounterSessionBasketUpdate = new EventEmitter();
  @Output() sendSelectedSession = new EventEmitter<any>();


  manageQuantityForm: UntypedFormGroup;
  sessionSelectedForm: UntypedFormGroup;
  innerWidth: number;
  quantity = 1;
  sessions: OfferSession[];
  sessionsChecked: OfferSession[];
  limitQuantity = Infinity;
  userKey: number;
  sessionsFiltered: OfferSession[] = [];
  newInputValueCopy: number;


  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private dataService: DataService,
    private sessionBasketService: SessionBasketService,
    private dialog: MatDialog,
    private uiService: UiService,
    private router: Router,
    private faIconService: FaiconService,
  ) { }

  ngOnInit() {
    this.initComponent();
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.offer) {
      this.fquantity?.quantity.setValue(changes.offer?.currentValue.traineeQuantity);
    }
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  updateQuantity(type: string, event?): void {
    setTimeout(() => {
      let value = this.fquantity.quantity.value;

      const { sessionBasketKey, sessions, sessionKey, trainees, counterSessionBasketKey } = this.offer;

      if (this.innerWidth < 1024) { this.dataService.updateBasketInMobile$.next(true); }

      switch (type) {
        case 'plus':
          if (value < this.limitQuantity) {
            value++;
            this.fquantity.quantity.setValue(value);
            // this.openDialogCustomizeSession();
          } else {
            this.uiService.showSnackbar(`Il n'y a que ${this.limitQuantity} ${this.limitQuantity > 1 ? 'places disponibles' : 'place disponible'}`);
          }
          break;

        case 'minus':
          value--;
          if (value >= 1) {
            this.fquantity.quantity.setValue(value);
          }
          break;
        case 'input':
          const input = document.getElementById(`myInput_${this.type}_${this.index}`);
          input.innerHTML = event === null ? 1 : event;
          break;

        default:
          break;
      }

      if (value === null) { this.fquantity.quantity.setValue(1); }

      this.quantity = value === 0 || value === null ? 1 : value;

      const updateQuantityOffer = !this.isCounter ?
        new SessionBasketTraineeQuantity(sessionBasketKey, this.userKey, this.quantity) :
        new CounterTraineeQuantity(this.counterSessionBasketKey, this.userKeyInAdmin, this.userKey, this.quantity);

      const check = sessions?.find(el => el.sessionKey === sessionKey);

      if (trainees?.length > this.quantity) {
        this.openDialogCustomizeSession();
        this.uiService.showSnackbar('Il y a trop de stagiaires pour cette session');
        // this.fsession.session.setValue('default');

        return;
      }

      this.updateQuantityValues.emit(updateQuantityOffer);
    });


  }

  openDialogCustomizeSession() {
    const { sessionBasketKey, sessions, sessionKey, trainees, counterSessionBasketKey } = this.offer;

    const dialogRef = this.dialog.open(OpendialogCustomizeMySessionComponent,
      {
        data: {
          offer: this.offer,
          quantity: this.quantity,
          showError: true,
          userKey: this.userKey,
          counterSessionBasketKey,
          sessionKey: sessionKey
        },
        minWidth: '50%',
        width: '100%',
        height: '80%',
        disableClose: true
      });

    dialogRef.afterClosed().subscribe({
      next: () => {
        this.dataService.afterUpdateTraineesInBasket$.next(true);

        if (counterSessionBasketKey) {
          this.getCounterSessionBasketUpdate.emit();
        }
      }
    });
  }

  updateSessionSelected(): void {
    const sessisonSelected = new SessionBasket(this.offer.sessionBasketKey, this.userKey, +this.fsession?.session.value);

    if (isNaN(sessisonSelected.sessionKey)) {
      sessisonSelected.sessionKey = null;
    }

    this.sessionBasketService.UpdateSession(sessisonSelected).subscribe({
      next: () => {
        const checkSession = new SelectBasketOffer(this.userKey, sessisonSelected.sessionBasketKey);

        this.sessionBasketService.checkSessionBasketComplete(checkSession).subscribe(() => {
          this.dataService.afterUpdateTraineesInBasket$.next(true);
          this.sendSessionSelected(sessisonSelected);
        });
      }
    });
  }

  sendSessionSelected(session) {
    this.sendSelectedSession.emit(session);
  }

  sessionFiltered(): OfferSession[] {
    let { sessions, offerKey, sessionKey } = this.offer;
    const { value: quantity } = this.fquantity.quantity;
    const sameOffer = this.myShoppingBag?.filter((o, i) => (o.offerKey === offerKey))[0];
    if (sameOffer) {
      sessions = sameOffer.sessions;
    }

    const check: OfferSession[] = sessions?.filter(session => (session?.quantity - session?.bookedSessionTrainees) >= quantity);
    if (check?.length === 0) {
      this.fsession.session.setValue('nosession');
    }

    const sameOfferSessionKey =
      this.myShoppingBag?.filter((o, i) => (o.offerKey === offerKey) && (i !== this.index)).map(o => o.sessionKey) || [];

    const checkCopy = check?.length ? [...check] : [];


    if (sameOfferSessionKey?.length) {
      sameOfferSessionKey?.forEach(key => {
        const indexKey = checkCopy?.findIndex(el => el.sessionKey === key);

        if (indexKey !== -1) {
          checkCopy?.splice(indexKey, 1);
        }
      });
    }

    const index = checkCopy?.findIndex(el => el.sessionKey === sessionKey);

    if (index === -1) { this.fsession.session.setValue('default'); }


    this.limitQuantity = Math.max(...checkCopy.map(s => s.quantity - s.bookedSessionTrainees));

    for (const item of checkCopy) {
      item.sessionStartDate = new Date(item.sessionStartDate);
    }


    return checkCopy.sort((a, b) => (a.sessionStartDate as any) - (b.sessionStartDate as any));
  }

  getMessageAddOfferToPaiment(disabled: boolean = false): void {
    this.uiService.showSnackbar('Vous devez selectionner l\'offre pour réaliser cette action');

    disabled ?
      this.fsession?.session.disable() :
      this.fsession?.session.enable();
  }

  needSession(): boolean {
    let check = false;
    const { hasSession, sessions } = this.offer;

    if (hasSession && sessions?.length) { check = true; }

    return check;
  }

  get fquantity() {
    return this.manageQuantityForm?.controls;
  }
  get fsession() {
    return this.sessionSelectedForm.controls;
  }

  private initComponent(): void {
    this.userKey = this.router.url.includes('admin') ? this.userKeyInAdmin : +this.authService.getDecodedToken().sub;
    this.innerWidth = window.innerWidth;
    const { hasSession, traineeQuantity, trainees, sessions } = this.offer;

    if (hasSession) {
      this.quantity = traineeQuantity > trainees?.length ?
        traineeQuantity : trainees?.length || 1;
    } else {
      this.quantity = traineeQuantity;
    }
    this.sessions = sessions || [];
  }

  private initForm(quantity?: number): void {
    let { traineeQuantity, sessionKey, hasSession } = this.offer;
    if (quantity) { this.quantity = quantity; }

    this.manageQuantityForm = this.formBuilder.group({
      // quantity: [this.isCounter ? this.updateQuantityValue : this.quantity || 1, Validators.pattern(/^-?(0|[1-9]\d*)?$/)]
      quantity: [this.isCounter ? this.updateQuantityValue : traineeQuantity || 1, Validators.pattern(/^-?(0|[1-9]\d*)?$/)]
    });

    if (hasSession) {
      this.sessionSelectedForm = this.formBuilder.group({
        session: [sessionKey ?? 'default']
      });

      this.sessionsFiltered = this.sessionFiltered();

      if (this.sessionsFiltered.length === 1 && !sessionKey) {
        sessionKey = this.sessionsFiltered[0].sessionKey;
        if (sessionKey) {
          this.sessionSelectedForm.get('session').setValue(sessionKey);
          this.updateSessionSelected();
        }

      }
    }

    let value = this.fquantity.quantity.value;
  }
}
